import { FIELD_PATHS, PII_FIELD_MASKING_CLASS } from '@funnels/constants';

import { TextInputField } from '@funnels/ui-components';
import { accountNumberParser, bsbFormatter, bsbParser, validateFixedLength } from '@funnels/utils';

export const PreferredRepaymentInstitutionNameTeamView = () => (
  <TextInputField
    name={FIELD_PATHS.APPLICATION_PREFERRED_REPAYMENT_INSTITUTION_NAME(0)}
    label="Institution Name"
    className={PII_FIELD_MASKING_CLASS}
    isOptional
  />
);

export const PreferredRepaymentAccountNameTeamView = () => (
  <TextInputField
    name={FIELD_PATHS.APPLICATION_PREFERRED_REPAYMENT_ACCOUNT_NAME(0)}
    label="Account Name"
    className={PII_FIELD_MASKING_CLASS}
    isOptional
  />
);

export const PreferredRepaymentBSBTeamView = () => (
  <TextInputField
    name={FIELD_PATHS.APPLICATION_PREFERRED_REPAYMENT_BSB(0)}
    label="BSB"
    format={bsbFormatter}
    parse={bsbParser}
    isOptional
    className={PII_FIELD_MASKING_CLASS}
    validate={validateFixedLength('Please provide a valid BSB number', 6, true)}
  />
);

export const PreferredRepaymentAccountNumberTeamView = () => (
  <TextInputField
    name={FIELD_PATHS.APPLICATION_PREFERRED_REPAYMENT_ACCOUNT_NUMBER(0)}
    label="Account Number"
    parse={accountNumberParser}
    className={PII_FIELD_MASKING_CLASS}
    isOptional
  />
);
